export default __webpack_public_path__ + "static/media/franquia.4bdca30c.png";